import React from 'react';

import { Box, Container } from '@mui/material';

import Navbar from 'src/online-payment/components/layout/Navbar';

// ----------------------------------------------------------------------

interface OnlinePaymentLayoutProps {
  children: React.ReactNode;
}

export default function OnlinePaymentLayout({ children }: OnlinePaymentLayoutProps) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', bgcolor: '#f8fafc' }}>
      {/* NAVBAR */}
      <Navbar />

      {/* MAIN CONTENT */}
      <Container
        maxWidth="xl"
        sx={{
          py: 4,
          flex: 1,
        }}
      >
        {children}
      </Container>
    </Box>
  );
}
